import { useEffect, useRef } from 'react';

export const useScrollAnimation = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            
            // Animate child elements with stagger
            const fadeIns = entry.target.querySelectorAll('.fade-in');
            fadeIns.forEach((el, index) => {
              setTimeout(() => {
                el.classList.add('visible');
              }, 100 * index);
            });
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    const sections = document.querySelectorAll('.section-transition');
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  return sectionRef;
};

export const useParallax = () => {
  useEffect(() => {
    const handleScroll = () => {
      const heroBg = document.querySelector('.hero-bg');
      if (heroBg) {
        const scrolled = window.pageYOffset;
        heroBg.style.transform = `translateY(${-0.5 * scrolled}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
};

